import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type UpdatePlaidRows = {
  label: vp.UpdatePlaidLabel;
  id: vp.UpdatePlaidId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const useBuildUpdatePlaidRows = (): UpdatePlaidRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Plaid.Update.Form' });

  return [
    {
      label: t('plaidClientId'),
      id: vp.UpdatePlaidId.PlaidClientID,
      preset: 'text',
      required: true,
    },
    {
      label: t('plaidSecretKey'),
      id: vp.UpdatePlaidId.PlaidSecretKey,
      preset: 'text',
      required: true,
    },
    {
      label: t('plaidUrl'),
      id: vp.UpdatePlaidId.PlaidUrl,
      preset: 'text',
      required: true,
    },
  ];
};
export default useBuildUpdatePlaidRows;
